import styled from "styled-components";

import { v } from "constants/css";

export const ModalTitle = styled.h3`
  font-weight: ${v.heavyFontWeight};
  line-height: 28px;
  margin-bottom: ${v.gUnit};
`;
